export enum MainMetrics {
    UnbrandedPI = 'Unbranded PI',
    BrandedPI = 'Branded PI',
    Uniqueness = 'Uniqueness',
    Frequency = 'Frequency',
    Draw = 'Draw',
    Value = 'Value'
}